import Vue from 'vue'
import { currencySymbol } from '@/helpers/intlFormatter.js'

export default function logEnvironmentDetails() {
  const locale = Vue.prototype.$locale
  const currency = Vue.prototype.$currency
  const settings = {
    'environment (APP_ENV from .env file)': window.environment, // local / test / staging / production
    'process.env.NODE_ENV': process.env.NODE_ENV,
    'Business unit name': window.businessUnitName,
    'Business unit key': window.businessUnitKey,
    locale,
    timezone: Vue.prototype.$timezone,
    currency,
    'currency symbol': currencySymbol(locale, Vue.prototype.$currency),
    twelvehourclock: Vue.prototype.$twelvehourclock,
    'defaultDateFormat (hardcoded)': Vue.prototype.$defaultDateFormat,
    'defaultDateTimeFormat (hardcoded)': Vue.prototype.$defaultDateTimeFormat,
    'Backend url': window.backendUrl,
  }
  console.group(
    '%c Running Vue',
    'background: #41B883; color: #35495E; font-weight: bold; font-size: 16px; padding: 0 200px; display: block;',
  )
  console.table(settings)
  const s = 'font-style: italic; font-weight: bold; color: maroon;'
  const info =
    'locale, timezone, currency and twelvehourclock come from %cwindow.i18n%c, which is json encoded in %cbase.blade.php%c from config settings, which in turn are set in %cAppServiceProvider.php%c from business unit settings, or default to values set in %capp.php%c'
  console.log(info, s, '', s, '', s, '', s, '')
  console.groupEnd()
}
